import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'practitioner-titles',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'practitioner-titles-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.practitioner-titles-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "practitioner-titles-index" */ '@/modules/configurations/catalogs/practitioner-titles/views/Index.vue')
        }
    ]
}
